import React from 'react';
import List from '../components/list';


const ReadMore = ({ ReadMoreLinks }) => {
  const matomoTrackingClass = 'läs-mer';
  if (!ReadMoreLinks || ReadMoreLinks.length < 1) return null;
  return (
    <div className="read-more">
      <List items={ReadMoreLinks} matomoTrackingClass={matomoTrackingClass} />
    </div>
  );
};

export default ReadMore;
